import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Alert, AlertType } from "../../_interfaces/alert";

@Injectable()
export class AlertService {

  private alert = new Subject<Alert>();

  onAlert(): Observable<Alert> {
    return this.alert.asObservable();
  }

  success(message: string, fadeOut: boolean = true): void {
    this.addAlert({ type: AlertType.Success, message, fadeOut } as Alert);
  }

  error(message: string, fadeOut: boolean = true): void {
    this.addAlert({ type: AlertType.Error, message, fadeOut } as Alert);
  }

  info(message: string, fadeOut: boolean = true): void {
    this.addAlert({ type: AlertType.Info, message, fadeOut } as Alert);
  }

  warn(message: string, fadeOut: boolean = true): void {
    this.addAlert({ type: AlertType.Warning, message, fadeOut } as Alert);
  }

  addAlert(alert: Alert): void {
    this.alert.next(alert);
  }

  clearAlert(): void {
    this.alert.next(null);
  }
}
